import { defineMessages } from 'react-intl';

const messages = defineMessages({
  affordableTransferBanner: {
    id: 'App.ManageUnitAvailability.AffordableTransferBanner',
    defaultMessage:
      'This project has more than one contract. You are only able to transfer from within the same contract, ' +
      'unless you perform a termination cert from the prior contract. Cancel the open Transfer on the ' +
      'Lease Data tab to enable the Start Certification button.',
  },
  floorplanTypeTransferRestrictionBanner: {
    id: 'App.ManageUnitAvailability.FloorplanTypeTransferRestrictionBanner',
    defaultMessage:
      'This is a mixed project. You are only able to transfer from one affordable unit to another affordable ' +
      'unit or one conventional unit to another conventional unit.',
  },
  singleBuildingElectionTooltip: {
    id: 'App.ManageUnitAvailability.SingleBuildingElectionTooltip',
    defaultMessage: 'Unable to Transfer to different building',
  },
  floorPlanTypeMismatchTooltip: {
    id: 'App.ManageUnitAvailabilityV2.FloorPlanTypeMismatchTooltip',
    defaultMessage:
      'Cannot assign this unit because its current (or scheduled) floor plan type does not match the household type.',
  },
  naurAssignmentRestriction: {
    id: 'App.ManageUnitAvailability.NaurAssignmentRestriction',
    defaultMessage:
      'Cannot assign a Market Rate unit in a building that is currently non-compliant ' +
      'with the Next Available Unit Rule (NAUR).',
  },
  hudContractMismatchTooltip: {
    id: 'App.ManageUnitAvailabilityV2.HudContractMismatchTooltip',
    defaultMessage:
      'This unit is on HUD contract {contractNumber} and cannot be assigned to this transfer.',
  },
  hudSubsidyMismatchTooltip: {
    id: 'App.ManageUnitAvailabilityV2.HudSubsidyMismatchTooltip',
    defaultMessage:
      'This unit is on HUD subsidy {subsidyName} and cannot be assigned to this transfer. ' +
      'Complete a termination certification first.',
  },
  hudSubsidyMismatchGenericTooltip: {
    id: 'App.ManageUnitAvailabilityV2.HudSubsidyMismatchGenericTooltip',
    defaultMessage:
      'This unit is on a different HUD subsidy and cannot be assigned to this transfer. ' +
      'Complete a termination certification first.',
  },
  affordableProgramMismatchTooltip: {
    id: 'App.ManageUnitAvailabilityV2.AffordableProgramMismatchTooltip',
    defaultMessage:
      'This unit is not on the same affordable program as this household and cannot be assigned to this transfer.',
  },
  invalidApplicationStatusTooltip: {
    id: 'App.ManageUnitAvailabilityV2.InvalidApplicationStatusTooltip',
    defaultMessage:
      'The application must be Approved or In Process before a unit can be assigned.',
  },
  unitOccupiedOnTransferDate: {
    id: 'App.ManageUnitAvailabilityV2.UnitOccupiedOnTransferDateTooltip',
    defaultMessage:
      'This unit is occupied on the selected transfer date and cannot be assigned.',
  },
  floorPlanQualificationRestriction: {
    id: 'App.ManageUnitAvailability.PreAssignmentQualificationRestriction',
    defaultMessage:
      "The selected unit does not match the household's assigned floorplan. " +
      'Choose a matching unit or update the floorplan assignment.',
  },
  assignmentRestrictionBanner: {
    id: 'App.ManageUnitAvailabilityV2.AssignmentRestrictionBanner',
    defaultMessage:
      'This list has been filtered to only show units this applicant qualifies for ' +
      'based on floor plan ({floorPlanName}) and waitlist configuration.',
  },
  assignmentRestrictionBannerNoFloorPlan: {
    id: 'App.ManageUnitAvailabilityV2.AssignmentRestrictionBannerNoFloorPlan',
    defaultMessage:
      'This list has been filtered to only show units this applicant qualifies for ' +
      'based on waitlist configuration.',
  },
  transferNavigationWarningBanner: {
    id: 'App.ManageUnitAvailabilityV2.TransferNavigationWarningBanner',
    defaultMessage:
      'Navigating away from this screen before selecting a unit will result in ' +
      'the new transfer being canceled.',
  },
});

export default messages;
